// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.88.2/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.88.2/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-xero-wrapper nb-icon {
  font-size: 1.2em;
}

.px-xero {
  padding: 24px;
  font-size: 14px;
  color: #222b45;
}

.px-xero-account {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border: 1px solid #edf1f7;
  border-radius: 6px;
  background: #f7f9fc;
}

.px-xero-account-text {
  flex: 1;
  min-width: 0;
}

.px-xero-line {
  font-weight: 600;
}

.px-xero-hint {
  font-size: 12.5px;
  color: #8f9bb3;
  margin-top: 1px;
}

.px-xero-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #00b887;
  margin-right: 5px;
  vertical-align: 1px;
}

.px-xero-orgs-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 24px 0 8px;
}

.px-xero-section {
  font-weight: 700;
}

.px-xero-org {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border: 1px solid #edf1f7;
  border-radius: 6px;
}
.px-xero-org > div {
  width: 100%;
}
.px-xero-org + .px-xero-org {
  margin-top: 8px;
}

.px-xero-org-name {
  font-weight: 600;
}

.px-xero-footnote {
  margin: 8px 0 0;
}

.px-xero-org-feeds {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #edf1f7;
}

.px-xero-feeds-text {
  font-size: 12.5px;
  color: #8f9bb3;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/home/profile/xero/profile-xero.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAGA;EACE,aAAA;EACA,eAAA;EACA,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,OAAA;EACA,YAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AAAF;;AAGA;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AAAF;AAEE;EACE,WAAA;AAAJ;AAGE;EACE,eAAA;AADJ;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,eAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;AAFF;;AAKA;EACE,iBAAA;EACA,cAAA;AAFF;AACA,4hGAA4hG","sourcesContent":[".profile-xero-wrapper nb-icon {\n  font-size: 1.2em;\n}\n\n// Connected state — two type sizes (14 base / 12.5 hint), quiet hairlines\n.px-xero {\n  padding: 24px;\n  font-size: 14px;\n  color: #222b45;\n}\n\n.px-xero-account {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  border: 1px solid #edf1f7;\n  border-radius: 6px;\n  background: #f7f9fc;\n}\n\n.px-xero-account-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.px-xero-line {\n  font-weight: 600;\n}\n\n.px-xero-hint {\n  font-size: 12.5px;\n  color: #8f9bb3;\n  margin-top: 1px;\n}\n\n.px-xero-dot {\n  display: inline-block;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #00b887;\n  margin-right: 5px;\n  vertical-align: 1px;\n}\n\n.px-xero-orgs-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 24px 0 8px;\n}\n\n.px-xero-section {\n  font-weight: 700;\n}\n\n.px-xero-org {\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  border: 1px solid #edf1f7;\n  border-radius: 6px;\n\n  > div {\n    width: 100%;\n  }\n\n  & + .px-xero-org {\n    margin-top: 8px;\n  }\n}\n\n.px-xero-org-name {\n  font-weight: 600;\n}\n\n.px-xero-footnote {\n  margin: 8px 0 0;\n}\n\n.px-xero-org-feeds {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px solid #edf1f7;\n}\n\n.px-xero-feeds-text {\n  font-size: 12.5px;\n  color: #8f9bb3;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
